$(document).ready(function(){
    //$('.rewards-banner-sec').css('display', 'none');
// Function to retrieve the customer Shopify ID
var customerShopifyId = $(".customer-id-jtpl").attr("data-customer-id");
//console.log('Customer Shopify ID:', customerShopifyId);

// Function to determine if the user is trying to access the rewards page
function isOnRewardsPage() {
    return window.location.href.includes('https://deyga.in/pages/rewards?_ab=0&_fd=0&_sc=1');
}

if (isOnRewardsPage() && !customerShopifyId) {
    // If user is trying to access rewards page but is NOT logged in
    console.log('User is not logged in. Redirecting to homepage...');
   // window.location.href = '/';
} else if (customerShopifyId) {
    // If logged in, proceed with API requests or other logic
    var apiUrl = 'https://rewards.deyga.in/api/customers?shopifyId=gid://shopify/Customer/' + customerShopifyId;
   // console.log('API URL:', apiUrl);
/************************************* Rewards first section***************************************/
    $.ajax({
        url: apiUrl,
        method: 'GET',
        headers: {
                  'Content-Type': 'application/json',
                   'Access-Control-Allow-Origin': '*',
                   'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                  'Access-Control-All-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token',
                  'Access-Control-Allow-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token'
                  },
        success: function(response) {
           console.log('Customer Details Response:', response);
          //  console.log(response.currentTier.tierId);
            if (response && response.currentTier.tierId) {
                var tierId = response.currentTier.tierId;
                var customername = response.name;
               var totalCustomerSavings=response.totalSpent;
               console.log('Tier ID:', tierId);
               // console.log('Customer Name:', customername);
                // Fetch tier details
                $.ajax({
                    url: 'https://rewards.deyga.in/api/tier/get/'+ tierId,
                    method: 'GET',
                  headers: {
                 'Content-Type': 'application/json',
                   'Access-Control-Allow-Origin': '*',
                   'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                  'Access-Control-All-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token',
                  'Access-Control-Allow-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token'
                  },
                    success: function(tierDetails) {
                        console.log('Tier Details:', tierDetails);
$('.rewards-banner-info').css({
    'background': 'linear-gradient(90deg, ' + tierDetails.benefitBackgroundColor1 + ', ' + tierDetails.benefitBackgroundColor2 + ')',
    'background-size': 'cover',
    'background-blend-mode': 'overlay'
});


   
                        $('.rewards-banner-title').text(customername);
                     // Assuming `tierDetails.tierName` contains the membership name
var membershipName = tierDetails.tierName; // Replace with your variable
$('.order_membership span').text("on " + membershipName + " membership");
                   $('.order_save_price h2').text("Saved Rs."+ totalCustomerSavings);
                        $('.rewards-header-title h2').text(tierDetails.tierName);
                        $('.rewards-header-title h4').text(tierDetails.programHeading);
                      //console.log("totalCustomerSavings"+totalCustomerSavings );
                        $('.rewards-save-price h5').html(`<strong>Rs.${totalCustomerSavings}</strong><span> Saved! </span><br>using Deyga Rewards`);
                       $('.rewards-header figure').html(`<img src="${tierDetails.tierIcon}" alt="Reward Icon">`);
                        $('.rewards-banner-sec').css('display', 'block');
                    },
                    error: function(error) {
                        console.error('Error fetching tier details:', error);
                    },
                });
            } else {
                console.log('No tierId found for the customer');
            }
        },
        error: function(error) {
            console.error('Error fetching customer details:', error);
        }
    });

  /***************** Rewards Range based on customer ***********************/
$.ajax({
    url: 'https://rewards.deyga.in/api/customers?shopifyId=gid://shopify/Customer/' + customerShopifyId,
    method: 'GET',
     headers: {
                'Content-Type': 'application/json',
                   'Access-Control-Allow-Origin': '*',
                   'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                  'Access-Control-All-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token',
                  'Access-Control-Allow-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token'
                  },
    success: function(response) {
        function hexToRgba(hex, opacity) {
    hex = hex.replace(/^#/, ''); // Remove the hash if it's there
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
      if (response.nextTier && response.nextTier.name != null && response.currentTier && response.currentTier.name != null) {
    // If both current and next tiers are present
    $('.current_tier').text(response.currentTier.name);
    $('.next_tier').text(response.nextTier.name);
      
      $('.more-to-reach').text("Spend Rs."+response.differenceToNextTier+" more to reach "+response.nextTier.name);
      
    // Get the RGBA colors with 60% opacity
    var rgbColor_border_1 = hexToRgba(response.currentTier.backgroundColor2, 0.6);
    var rgbColor_border_2 = hexToRgba(response.nextTier.backgroundColor2, 0.6);
    var bckgroundcolor=response.currentTier.backgroundColor1;
     var  bckgroundcolor2=response.nextTier.backgroundColor1;
} else {
    // If either nextTier or currentTier is null, use previousTier
    $('.current_tier').text(response.previousTier ? response.previousTier.name : 'No Previous Tier');
    $('.next_tier').text(response.currentTier ? response.currentTier.name : 'No Next Tier');
     $('.more-to-reach').text(response.currentTier ? "Congrats! All the benefits are now unlocked for you!" :"Shop for Rs. 2000 to start earning rewards");
    // Get the RGBA colors with 60% opacity
    var rgbColor_border_1 = response.previousTier ? hexToRgba(response.previousTier.backgroundColor2, 0.6) : 'rgba(0, 0, 0, 0.6)';
    var rgbColor_border_2 = response.currentTier ? hexToRgba(response.currentTier.backgroundColor2, 0.6) : 'rgba(0, 0, 0, 0.6)';
     var bckgroundcolor=response.previousTier.backgroundColor1;
     var  bckgroundcolor2=response.currentTier.backgroundColor1;
}

       
      
        var currentTierId = response.currentTier.tierId;
      console.log(currentTierId);
        var totalSpent =response.totalSpent;// Example, adjust this based on the actual spend
       //var totalSpent = 2900;
         var cstmcolor=response.currentTier.backgroundColor1;
        $.ajax({
            url: 'https://rewards.deyga.in/api/tier/get/active',
            method: 'GET',
headers: {
          'Content-Type': 'application/json',
             'Access-Control-Allow-Origin': '*',
             'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
            'Access-Control-All-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token',
            'Access-Control-Allow-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token'
            },
            success: function(tiers) {
                console.log("All active tiers", tiers);

                // Find matching tier index
                var matchingIndex = tiers.findIndex(tier => tier.tierId === currentTierId);
                var previousDetails = { rangeFrom: 0, rangeTo: 2000 };  // Default for first tier
                var matchingDetails, nextDetails;
                var noTierDetails = 0;
              console.log("hereeee");
console.log(matchingIndex);
                // Handle previous, current, and next tiers
                if (matchingIndex !== -1) {
                    matchingDetails = tiers[matchingIndex];

                    // Previous tier
                    if (matchingIndex > 0) {
                        previousDetails = tiers[matchingIndex - 1];
                    }

                    // Next tier
                 if (matchingIndex < tiers.length - 1 ) {
                        nextDetails = tiers[matchingIndex + 1];
                   
                    }
                }else{
                  matchingDetails=0;
                 // matchingDetails = tiers[0];
                  nextDetails = tiers[0];
                  noTierDetails = 1;
                }
     console.log("Next Details");     console.log(nextDetails);    
                // Calculate the width of the current progress bar
                var spentRangeFrom = matchingDetails.rangeFrom || 0;
                var spentRangeTo = matchingDetails.rangeTo || 2000;
              console.log("spentRangeFrom"+spentRangeFrom+"spentRangeTo"+spentRangeTo)
                var width = 0;

                // If the spend is within the current tier range, calculate the progress
                if (totalSpent > spentRangeFrom && totalSpent < spentRangeTo) {
                    var range = spentRangeTo - spentRangeFrom;
                    var percentage = ((totalSpent - spentRangeFrom) / range) * 100;
                    width = Math.min(percentage, 100);
                 
                } else  if (totalSpent > spentRangeTo) {
                    // If the customer has exceeded the current tier range, set the bar to 100% (complete)
                    width = 100;
                }
// console.log("Current==="+width);
                // Calculate the width of the previous tier bar
                var previousTierWidth = 0;
              console.log("previousDetails.rangeFrom"+previousDetails.rangeFrom+"previousDetails.rangeTo"+previousDetails.rangeTo);
              if(response.currentTier.name == 'Start'){
                 previousTierWidth = 100;
              } else if (totalSpent > previousDetails.rangeFrom && totalSpent < previousDetails.rangeTo) {
                    var previousRange = previousDetails.rangeTo - previousDetails.rangeFrom;
                    var previousPercentage = ((totalSpent - previousDetails.rangeFrom) / previousRange) * 100;
                    previousTierWidth = Math.min(previousPercentage, 100);
                
                }else if (totalSpent >= previousDetails.rangeTo) {
                    // If the customer has exceeded the current tier range, set the bar to 100% (complete)
                    previousTierWidth = 100;
                }
         // console.log("Previous Tier width : ==="+previousTierWidth);
                // Calculate the width of the next tier bar
                var nextTierWidth = 0;
              if(nextDetails){
               //  console.log("hereee--next==="+nextDetails.rangeFrom+"===="+nextDetails.rangeTo);
                if (nextDetails && totalSpent >= nextDetails.rangeFrom) {
                    var nextRange = nextDetails.rangeTo - nextDetails.rangeFrom;
                    var nextPercentage = ((totalSpent - nextDetails.rangeFrom) / nextRange) * 100;
                    nextTierWidth = Math.min(nextPercentage, 100);
                  //  console.log("hereee--next----");console.log(nextTierWidth);
                }
              }else if (totalSpent >= previousDetails.rangeTo) {
                nextTierWidth=100;
                 width = 100;
                 previousTierWidth = 100;
              }
           // console.log("Nexy Tier width : ==="+nextTierWidth);
              

               // Calculate tooltip positions for each tier
var previousTooltipPosition = Math.min(previousTierWidth, 100);
var currentTooltipPosition = Math.min(width, 100);
var nextTooltipPosition = Math.min(nextTierWidth, 100);
// console.log("nextDetails.rangeFrom: "+ nextDetails.rangeFrom )
// Generate progress bars with tooltips
var progressBars = `
    <div class="rewards-range-bar previous-tier" style="width: 20%; background-color: #B3B3B3; position: relative;">
        <span class="progress-bar" style="height: 100%; width: ${previousTierWidth}%; background-color: ${cstmcolor};"></span>
        <span class="tooltip" style="left: ${previousTooltipPosition}%; display: ${totalSpent >= previousDetails.rangeFrom && totalSpent <= previousDetails.rangeTo ? (response.currentTier.name === 'Start' ? 'none' : 'block') : 'none'};">
            You are here
        </span>
    </div>
    <span class="rewards-range-previous"></span>
    <div class="rewards-range-bar current-tier" style="width: 100%; background-color: #B3B3B3; position: relative;">
        <span class="progress-bar" style="height: 100%; width: ${currentTooltipPosition}%; background-color: ${cstmcolor};"></span>
        <span class="tooltip" style="left: ${currentTooltipPosition}%; display: ${totalSpent >= spentRangeFrom && totalSpent <= spentRangeTo ? 'block' : 'none'};">
            You are here
        </span>
    </div>
    <span class="rewards-range-next"></span>
    <div class="rewards-range-bar next-tier" style="width: 20%; background-color: #B3B3B3; position: relative;">
        <span class="progress-bar" style="height: 100%; width: ${nextTierWidth}%; background-color: ${cstmcolor};"></span>
        <span class="tooltip" style="left: ${nextTooltipPosition}%; display: ${nextDetails && totalSpent >= nextDetails.rangeFrom ? 'block' : 'none'};">
            You are here
        </span>
    </div>
`;

// Append the progress bars to the .rewards-range div
$('.rewards-range').empty().append(progressBars);

var styleElement = document.createElement('style');
document.head.appendChild(styleElement);
var stylesheet = styleElement.sheet;
stylesheet.insertRule(`
    span.rewards-range-previous:before {
        background-color: ${bckgroundcolor};
        border: 4px solid ${rgbColor_border_1};
        box-shadow: 0px 0px 2px ${rgbColor_border_1};
    }
`, stylesheet.cssRules.length);
stylesheet.insertRule(`
    span.rewards-range-next:before {
        background-color: ${bckgroundcolor2};
        border: 4px solid ${rgbColor_border_2};
        box-shadow: 0px 0px 2px ${rgbColor_border_2};
    }
`, stylesheet.cssRules.length);
            },
            error: function(error) {
                console.error("Error fetching tier details", error);
            }
        });
    },
    error: function(error) {
        console.error("Error fetching customer details", error);
    }
});







  /***************************** Milestone section ************************************/

 
  $(document).ready(function() {
    // Function to generate milestone HTML
    function generateMilestoneHtml(index, imageSrc, width, color, tier) {
        var isMobile = window.innerWidth <= 767;
        console.log("isMobile"+isMobile);
        var milestoneHtml = `
            <div class="milestone-bar cstm_milestone_${index + 1}">
                <div class="milestone-bar-top">
                    <div class="milestone-bar-img">
                        ${imageSrc}
                        <div class="bar-rotate">
                            <span class="mile-bar"></span>
                            <span class="mile-bar fill" 
                            style="${isMobile ? 'height:' + width + '%; width:6px;' : 'width:' + width + '%;'} 
                                background-color: ${color};"></span>
                        </div>
                    </div>
                    <h4 style="background-color: ${tier.backgroundColor}">${tier.tierName}</h4>
                </div>
                <div class="milestone-bar-bottom">
                    <h3>${tier.programHeading}</h3>
                    <p>${tier.programSubDescription}</p>
                </div>
            </div>`;

        return milestoneHtml;
    }

    // Function to update milestone bars
    function updateMilestoneBars(response) {
        $('#milestoneBars').empty(); // Clear existing milestones
        
        response.allTiers.forEach(function(tier, index) {
            var customerSpend = response.customerSpends;
            var spentRangeFrom = tier.spentRangeFrom || 0;
            var spentRangeTo = tier.spentRangeTo || 0;
            var width = calculateWidth(customerSpend, spentRangeFrom, spentRangeTo);
            var color = tier.backgroundColor;
            var imageSrc = determineImageSrc(customerSpend, spentRangeFrom, spentRangeTo, color);
            var rgbColor = hexToRgba(color, 0.6);
                var greyColor = 'rgba(179, 179, 179, 0.6)'; 
            var milestoneHtml = generateMilestoneHtml(index, imageSrc, width, color, tier);
            $('#milestoneBars').append(milestoneHtml);
              if (customerSpend >= spentRangeFrom && customerSpend <= spentRangeTo) {
           $(`.cstm_milestone_${index + 1} .milestone-bar-img svg`).css({
                "border": `4px solid ${rgbColor}`
            });
        } else if (customerSpend < spentRangeFrom) {
           $(`.cstm_milestone_${index + 1} .milestone-bar-img svg`).css({
                "border": `4px solid ${greyColor}`
            });
        } else {
          $(`.cstm_milestone_${index + 1} .milestone-bar-img svg`).css({
                "border": `4px solid ${rgbColor}`
            });
        }
           
        });
    }

    // Function to calculate the width of the progress bar
    function calculateWidth(customerSpend, spentRangeFrom, spentRangeTo) {
        var range = spentRangeTo - spentRangeFrom;
        var percentage = ((customerSpend - spentRangeFrom) / range) * 100;
        return Math.min(Math.max(percentage, 0), 100).toFixed(2);
    }

    // Function to determine the image source based on the customer's spend
    function determineImageSrc(customerSpend, spentRangeFrom, spentRangeTo, color) {
        if (customerSpend >= spentRangeFrom && customerSpend <= spentRangeTo) {
         // console.log("cstmcolor1");
            return getNormalMilestoneImage(color);
        } else if (customerSpend < spentRangeFrom) {
          //console.log("cstm_color_2");
            return getLockedMilestoneImage();
        } else {
         // console.log("cstmcolor_3");
            return getNormalMilestoneImage(color);
        }
    }

    // AJAX request to fetch milestone data
    $.ajax({
        url: 'https://rewards.deyga.in/api/tier/get/milestones?shopifyId=gid://shopify/Customer/' + customerShopifyId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'https://deyga.in'
        },
        success: function(response) {
            if (response.allTiers && Array.isArray(response.allTiers)) {
                updateMilestoneBars(response);
              $('.milestone-wrapper').css('display', 'block');
            } else {
                console.log("No tiers found in the response");
            }
        },
        error: function(error) {
            console.log("Error fetching data: ", error);
        }
    });

    // Handle window resize
    $(window).resize(function() {
        $.ajax({
            url: 'https://rewards.deyga.in/api/tier/get/milestones?shopifyId=gid://shopify/Customer/' + customerShopifyId,
            method: 'GET',
           headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'https://deyga.in'
    },
            success: function(response) {
                if (response.allTiers && Array.isArray(response.allTiers)) {
                    updateMilestoneBars(response);
                  $('.milestone-wrapper').css('display', 'block');
                }
            }
        });
    });

    // Utility function to convert hex to rgba
    function hexToRgba(hex, opacity) {
        hex = hex.replace(/^#/, '');
        var r = parseInt(hex.substring(0, 2), 16);
        var g = parseInt(hex.substring(2, 4), 16);
        var b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    // Utility functions to return SVG images
    function getNormalMilestoneImage(color) {
        return `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0012 27.7407C21.5893 27.7407 27.7407 21.5893 27.7407 14.0012C27.7407 6.41312 21.5893 0.261742 14.0012 0.261742C6.41309 0.261742 0.261719 6.41312 0.261719 14.0012C0.261719 21.5893 6.41309 27.7407 14.0012 27.7407Z" fill="${color}"/>
                    <path d="M11.875 17.0386L7.16753 12.3312L6.91666 12.0804L6.66579 12.3312L5.24913 13.7479L4.99826 13.9987L5.24913 14.2496L11.6241 20.6246L11.875 20.8754L12.1259 20.6246L22.7509 9.99959L23.0017 9.74873L22.7509 9.49786L21.3342 8.08119L21.0834 7.83033L20.8325 8.08119L11.875 17.0386Z" fill="#ffffff" stroke="#ffffff" stroke-width="0.709562"/>
                </svg>`;
    }

    function getLockedMilestoneImage() {
        return `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2011 27.7407C21.7893 27.7407 27.9406 21.5893 27.9406 14.0012C27.9406 6.41314 21.7893 0.261765 14.2011 0.261765C6.61304 0.261765 0.46167 6.41314 0.46167 14.0012C0.46167 21.5893 6.61304 27.7407 14.2011 27.7407Z" fill="#B3B3B3"/><path d="M19.1996 12.6269H18.5548V10.3566C18.5548 7.95444 16.6005 6.00005 14.1982 6.00005C11.7961 6.00005 9.84172 7.95444 9.84172 10.3567V12.627H9.19702C8.68739 12.627 8.27417 13.0401 8.27417 13.5498V21.0772C8.27417 21.5869 8.68735 22 9.19702 22H19.1996C19.7092 22 20.1223 21.5869 20.1223 21.0772V13.5498C20.1223 13.0401 19.7092 12.6269 19.1996 12.6269ZM15.1805 19.2373H13.216L13.5676 17.5619C13.2388 17.3527 13.0192 16.9873 13.0192 16.5687C13.0192 15.9176 13.5471 15.3897 14.1983 15.3897C14.8494 15.3897 15.3773 15.9176 15.3773 16.5687C15.3773 16.9873 15.1577 17.3527 14.8289 17.5619L15.1805 19.2373ZM17.0003 12.6269H11.3962V10.3566C11.3962 8.81141 12.6531 7.55451 14.1983 7.55451C15.7435 7.55451 17.0003 8.81144 17.0003 10.3566V12.6269Z" fill="#F4F5F5"/></svg>`;
    }
});

/************************* Benfits section js******************************/
$.ajax({
  url: 'https://rewards.deyga.in/api/tier/get/active',
  method: 'GET',
 headers: {
               'Content-Type': 'application/json',
                   'Access-Control-Allow-Origin': 'https://deyga.in',
                   'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                  'Access-Control-All-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token',
                  'Access-Control-Allow-Headers': 'Content-Type, X-Shopify-Storefront-Access-Token'
                   },
  success: function(response) {
    response.forEach(function(item, index) {
      const targetClass = `.benifits.tier_${index+1} .image-with-heading`;
      // $(`.benifits .tier_${index+1}`).css({
      //   'border': `1.32px solid ${item.benefitBackgroundColor2}`
      //     });
          console.log("index "+ (index+1)+" tierid   "+item.tierId+"  Benefit response  "+item.benefitTitle);
      $(targetClass).css({
        'background': `linear-gradient(90deg, ${item.benefitBackgroundColor1}, ${item.benefitBackgroundColor2})`
      });
     $(`${targetClass} h3`).text(item.benefitTitle).css('text-transform', 'capitalize');
       $(`${targetClass}  img`).attr('src', item.tierIcon);
       // Apply the border color on the parent .benifits class based on the API response

      $(`.benifits.tier_${index+1}`).css({
        'border': `1.32px solid ${item.benefitBackgroundColor2}`  // Apply border color from the response
      });
    const benefitDescriptions = item.benefitDescription; // Array of descriptions
      for (var i = 0; i < benefitDescriptions.length; i++) {
          const benefitClassPrefix = `.cstm_unlok_${index+1} .benefit_description_${i+1}`;
          $(`.cstm_unlok_${index+1} h4`).text(item.nextTierTitle);
         $(benefitClassPrefix).html(
    `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.9581 16.6672C12.3338 16.6672 15.881 13.1199 15.881 8.74423C15.881 4.36851 12.3338 0.821289 7.9581 0.821289C3.58238 0.821289 0.0351562 4.36851 0.0351562 8.74423C0.0351562 13.1199 3.58238 16.6672 7.9581 16.6672Z" fill="${item.benefitBackgroundColor1}"/><path d="M6.97257 10.5507L4.23003 7.80821L4.11331 7.69149L3.9966 7.80821L3.17967 8.62513L3.06295 8.74184L3.17967 8.85856L6.85585 12.5347L6.97257 12.6514L7.08929 12.5347L13.2162 6.40776L13.333 6.29105L13.2162 6.17433L12.3993 5.35741L12.2826 5.24069L12.1659 5.35741L6.97257 10.5507Z" fill="#ffffff" stroke="#ffffff" stroke-width="0.330122"/></svg>` +
    benefitDescriptions[i]
);

}
   const benefittext = item.benefits; // Array of descriptions
     // console.log(benefittext)
      for (var i = 0; i < benefittext.length; i++) {
          const benefittextPrefix = `.benifitpoint_${index + 1} .benifitpoint_in_${i + 1}`;
   // console.log(benefittextPrefix);

    // Update each element with the image and title
    $(benefittextPrefix).html(`
        <img src="${benefittext[i].benefitIcon}" alt="Benefit Image">
        <h5> ${benefittext[i].title}</h5>
    `);
        //  $(benefittextPrefix).html(benefittext[i]);
}
     // console.log("response.ctaButtonDescription"+ item.ctaDescription)
      $(`.tier_${index + 1} .benifit-btn p`).text(item.ctaDescription);
     $(`.tier_${index + 1} .benifit-btn a`)
    .attr('href', item.ctaButtonLink)
    .html(`${item.ctaButtonName} <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/right.svg?v=1727776272">`);

      
    });
     
    
  },
  error: function(xhr, status, error) {
    console.error('Error fetching data:', error);
  }
});



} else {
    console.log('Customer is not logged in');
}
});